import { stdObject } from "../../../../data/types/stdObject";

export const writeDataResults = ({
  id,
  searchValues,
  responseReportData,
}: stdObject) => {
  return {
    ...searchValues,
    [id]: {
      ...searchValues[id],
      results: responseReportData.results,
    },
  };
};
